import { render, staticRenderFns } from "./user-select-widget.vue?vue&type=template&id=290c91f6&scoped=true&"
import script from "./user-select-widget.vue?vue&type=script&lang=js&"
export * from "./user-select-widget.vue?vue&type=script&lang=js&"
import style0 from "./user-select-widget.vue?vue&type=style&index=0&id=290c91f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290c91f6",
  null
  
)

export default component.exports